import React from 'react';

/**
 * TimelineHeader Component
 * 
 * Renders the top navigation row of the timeline grid, including the date label,
 * the all-day toggle/resizer area, and the hour labels for the time grid.
 * 
 * @param {Object} props
 * @param {number} props.actualAlldayWidth - Current width of the all-day column
 * @param {boolean} props.isAllDayCollapsed - Whether the all-day section is collapsed
 * @param {Function} props.setIsAllDayCollapsed - Toggle function for all-day section
 * @param {number} props.TIMELINE_WIDTH - Total calculated width of the hour grid
 * @param {number} props.hourStart - Starting hour of the grid (e.g. 5)
 * @param {number} props.hourEnd - Ending hour of the grid (e.g. 22)
 * @param {number} props.GRID_BUFFER - Offset for the first hour label
 * @param {number} props.dynamicHourWidth - Pixel width per hour slot
 * @returns {JSX.Element}
 */
export function TimelineHeader({
    actualAlldayWidth,
    isAllDayCollapsed,
    setIsAllDayCollapsed,
    TIMELINE_WIDTH,
    hourStart,
    hourEnd,
    GRID_BUFFER,
    dynamicHourWidth
}) {
    return (
        <div className="timeline-header-row" style={{ height: 47, display: 'flex', width: 'max-content', minWidth: '100%', position: 'sticky', top: 0, zIndex: 700, background: '#f8fafc', boxSizing: 'border-box', borderBottom: '2px solid #cbd5e1' }}>
            {/* Date Label */}
            <div className="timeline-day-label" style={{ width: 80, minWidth: 80, height: '100%', position: 'sticky', left: 0, zIndex: 710, justifyContent: 'center', flex: 'none', background: '#f8fafc', display: 'flex', alignItems: 'center', borderRight: 'none', boxSizing: 'border-box', borderBottom: 'none' }}>
                <span style={{ fontSize: '0.65rem', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Datum
                </span>
            </div>
            
            {/* All-Day Toggle Header */}
            <div className="timeline-allday-col" style={{ 
                width: actualAlldayWidth, 
                minWidth: actualAlldayWidth, 
                height: '100%', 
                position: 'sticky',
                left: 80,
                zIndex: 710,
                padding: 0,
                boxSizing: 'border-box',
                overflow: 'visible',
                flex: 'none',
                background: '#f8fafc',
                borderLeft: '2px solid #cbd5e1',
                borderRight: 'none',
                borderBottom: 'none'
            }}>
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    gap: '4px',
                    padding: '0 4px',
                    boxSizing: 'border-box',
                    borderBottom: 'none'
                }}>
                    {!isAllDayCollapsed && actualAlldayWidth >= 100 && (
                        <span style={{ fontSize: '0.65rem', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', whiteSpace: 'nowrap', letterSpacing: '0.5px' }}>
                            Ganztag
                        </span>
                    )}
                    <button 
                        onClick={() => setIsAllDayCollapsed(!isAllDayCollapsed)}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '0.65rem',
                            padding: '2px',
                            color: '#94a3b8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        title={isAllDayCollapsed ? "Ganztag einblenden" : "Ganztag ausblenden"}
                    >
                        {isAllDayCollapsed ? '▶' : '◀'}
                    </button>
                </div>
            </div>

            {/* Hour Labels */}
            <div className="timeline-time-header" style={{ minWidth: TIMELINE_WIDTH, height: '100%', position: 'relative', flex: 'none', zIndex: 700, background: '#f8fafc', borderLeft: '2px solid #cbd5e1', borderRight: 'none', borderBottom: 'none', boxSizing: 'border-box' }}>
                {Array.from({ length: hourEnd - hourStart + 1 }, (_, i) => (
                    <div key={i} className="timeline-hour-label" style={{ left: GRID_BUFFER + (i * dynamicHourWidth) }}>
                        {hourStart + i}:00
                    </div>
                ))}
            </div>
        </div>
    );
}
